module.exports = __webpack_public_path__ + "static/media/Totaljobs-totem.e8ba5b76.svg";